import React, {useEffect, useState} from "react";
import BaseModal from "../../modals/base-modal";

const SaleStepSummary = ({show, onClose, onBack, onNext, data}) => {
    const [products, setProducts] = useState(data || []);

    const handleQuantityChange = (id, delta) => {
        setProducts((prev) =>
            prev.map((p) =>
                p.product_id === id
                    ? {...p, quantity: Math.max(1, p.quantity + delta)}
                    : p
            )
        );
    };

    const handleRemove = (id) => {
        setProducts((prev) => prev.filter((p) => p.product_id !== id));
    };

    const subtotal = products.reduce(
        (acc, p) => acc + (p.sale_price_per_unit ?? p.price) * p.quantity,
        0
    );

    useEffect(() => {
        setProducts(data || []);
    }, [data]);

    return (
        <BaseModal
            show={show}
            onClose={onClose}
            title="Resumen de compra"
            onSave={() => onNext({products, subtotal})}
            saveText="Continuar"
            size="lg"
            backable={true}
            onBack={onBack}
        >
            <div className="px-3">
                <table className="sale-modal-table-products table align-middle">
                    <thead>
                    <tr>
                        <th className="p-0"></th>
                        <th>Producto</th>
                        <th className="text-center">Precio</th>
                        <th className="text-center">Cantidad</th>
                        <th className="text-center">Subtotal</th>
                    </tr>
                    </thead>
                    <tbody>
                    {products.map((p) => (
                        <tr key={p.product_id}>
                            <td className="p-0">
                                <svg
                                    type="button"
                                    onClick={() => handleRemove(p.product_id)}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM9.63086 8.22363C9.23809 7.90369 8.65894 7.927 8.29297 8.29297C7.927 8.65894 7.90369 9.23809 8.22363 9.63086L8.29297 9.70703L10.5859 12L8.29297 14.293C7.90244 14.6835 7.90244 15.3165 8.29297 15.707C8.68349 16.0976 9.31651 16.0976 9.70703 15.707L12 13.4141L14.293 15.707C14.6835 16.0976 15.3165 16.0976 15.707 15.707C16.0976 15.3165 16.0976 14.6835 15.707 14.293L13.4141 12L15.707 9.70703L15.7764 9.63086C16.0963 9.23809 16.073 8.65894 15.707 8.29297C15.3411 7.927 14.7619 7.90369 14.3691 8.22363L14.293 8.29297L12 10.5859L9.70703 8.29297L9.63086 8.22363Z"
                                        fill="#FF644B"
                                    />
                                </svg>
                            </td>
                            <td className="sale-modal-summary-products-table-label text-truncate">
                                {p.name}
                            </td>
                            <td className="sale-modal-summary-products-table-label text-center">
                                ${(p.sale_price_per_unit ?? p.price).toLocaleString("es-CO")}
                            </td>
                            <td className="text-center">
                                <div
                                    className="d-flex align-items-center bg-white border border-1 rounded sale-modal-summary-products-table-label justify-content-between">
                                    <button
                                        type="button"
                                        className="btn btn-sm border-0"
                                        onClick={() => handleQuantityChange(p.product_id, -1)}
                                    >
                                        -
                                    </button>
                                    <span className="sale-modal-summary-products-table-label">
                                        {p.quantity}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-sm border-0"
                                        onClick={() => handleQuantityChange(p.product_id, 1)}
                                    >
                                        +
                                    </button>
                                </div>
                            </td>
                            <td className="sale-modal-summary-products-table-label text-center">
                                ${((p.sale_price_per_unit ?? p.price) * p.quantity).toLocaleString("es-CO")}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

                <div className="d-flex flex-column gap-1">
                    <span className="sale-modal-table-resume-title">Total</span>
                    <div className="d-flex justify-content-between">
                        <span className="sale-modal-table-resume-subtitle">Subtotal</span>
                        <span className="sale-modal-summary-products-table-label">
                            ${subtotal.toLocaleString("es-CO")}
                        </span>
                    </div>
                    <div className="d-flex justify-content-between">
                        <span className="sale-modal-table-resume-subtitle">Total</span>
                        <span className="sale-modal-summary-products-table-label fw-bold">
                            ${subtotal.toLocaleString("es-CO")}
                        </span>
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};

export default SaleStepSummary;
